$('fieldset[readonly]').find('input, textarea, select').prop('readonly', true);
